import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

// filters = {
//   search, sourceStatusCode, workflowStatusCode, uploadId,
//   careGapNameSearch, careGapTypeId, page, pageSize, orderBy
// }
const getCareGaps = async (filters = {}) => {
  try {
    const response = await axios.get(API_URL, {
      params: {
        search: filters.search,
        sourceStatusCode: filters.sourceStatusCode,
        workflowStatusCode: filters.workflowStatusCode,
        uploadId: filters.uploadId,
        careGapNameSearch: filters.careGapNameSearch,
        careGapTypeId: filters.careGapTypeId,
        page: filters.page || 1,
        pageSize: filters.pageSize || 50,
        orderBy: filters.orderBy
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching care gaps:", error);
    throw error;
  }
};

export default getCareGaps;
